module.exports = __webpack_public_path__ + "static/media/getDefinition.js.0c48668e.flow";


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-language-service-interface/dist/getDefinition.js.flow
// module id = 407
// module chunks = 0 1